import MainLayout from "components/layout/main-layout/MainLayout";
import { titles } from "constants/titles";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import { finilizeMyCancelRequest, getCancelSubscriptionList, undoMyCancelRequest } from "redux/MedicalAlertUsers/actions";
import './SubscriptionList.css'
import { convertInRequiredTimeZone, formatDate, getStatusColor } from "utility";
import CustomButton from "components/widgets/custom-button/CustomButton";
import ConfirmationModal from "components/layout/confirmation-modal/ConfirmationModal";
import SnackBar from "components/widgets/snack-bar/SnackBar";
import { ROUTES_CONSTANTS } from "routes/route-constants";

const SubscriptionList = () => {
    const [showUndoRequestPopup, setIsShowUndoRequestPopup] = useState(false);
    const [isUndoRequest, setIsUndoRequest] = useState(false);
    const [currentPopUpData, setCurrentPopUpData] = useState(null);
    const [snackBarMessage, setSnackBarMessage] = useState({
        message: "",
        type: "",
    });

    const userData = useSelector((store) => store?.auth?.userData);
    const { cancelSubscriptionList, loading, selectedMedicalUser } = useSelector((store) => store?.medicalAlertUsers);
    const { currentTimeZone } = useSelector((store) => store?.common);

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const medicalUserData = location?.state?.medicalUserData;;

    useEffect(() => {
        getSubscriptionList();
    }, []);

    const renderKeyLabels = (title) => (
        <p className="key-label">{title}</p>
    );

    const renderKeyValues = (value) => (
        <p className="key-value-label">{value}</p>
    );

    const renderStatusBadge = (status) => {
        let label = null;

        switch (status) {
            case "cancelled":
                label = titles?.withdrawn;
                break;
            case "draft":
                label = titles?.action_required;
                break;
            case "waiting_for_doc":
                label = titles?.under_review;
                break;
            case "denied":
                label = titles?.denied;
                break;
            case "pending_cancel":
                label = titles?.scheduledToCancel;
                break;
            case "completed":
                label = titles?.completed;
                break;
            default:
                return null;
        }

        const badgeColor = getStatusColor(status);

        return (
            <div className="status-badge" style={{ backgroundColor: badgeColor }}>
                <span className="status-badge-label">{label}</span>
            </div>
        );
    };


    const getSubscriptionList = () => {
        const params = {
            dispatch,
            payload: {
                medical_alert_user_id: medicalUserData?.medical_alert_user_id,
            },
            userType: userData?.isGuestUser ? "guestuser" : "accountowner",
            history,
        };
        getCancelSubscriptionList(params);
    };

    const convertInLocalTimeZone = (date) => {
        return convertInRequiredTimeZone(
            date,
            selectedMedicalUser?.timezone,
            currentTimeZone
        );
    };

    const onUndoRequest = (item) => {
        setIsUndoRequest(true);
        setCurrentPopUpData(item);
        setIsShowUndoRequestPopup(true);
    };

    const onFinilizeRequest = (item) => {
        setIsUndoRequest(false);
        setCurrentPopUpData(item);
        setIsShowUndoRequestPopup(true);
    };
    const onClose = () => {
        setIsShowUndoRequestPopup(false);
    };

    const onPressCard = (item) => {
        history.push(ROUTES_CONSTANTS.subscriptionDetail, {
            medicalUserData: medicalUserData,
            requestData: item,
        });
    }

    const handleOnConfirmYes = () => {
        const params = {
            dispatch,
            payload: {
                medical_alert_user_id: selectedMedicalUser?.medical_alert_user_id,
                request_id: currentPopUpData?.request_id,
            },
            userType: userData?.isGuestUser ? "guestuser" : "accountowner",
            history,
            successCallBack: () => getSubscriptionList(),
            setSnackBarMessage
        };
        if (isUndoRequest) {
            undoMyCancelRequest(params);
        } else {
            finilizeMyCancelRequest(params);
        }
        setIsShowUndoRequestPopup(false);
    };

    const renderSubscriptionItem = (item) => {
        return (
            <div className="card-wrapper">
                {renderStatusBadge(item?.status)}
                <div className="lower-content-wrapper">
                    <div className="request-detail-container">
                        {renderKeyLabels(titles?.request_id)}
                        {renderKeyValues(item?.request_number)}
                    </div>
                    <div className="request-detail-container">
                        {renderKeyLabels(titles?.account)}
                        {renderKeyValues(item?.account_no)}
                    </div>
                </div>

                <div className="lower-content-wrapper">
                    <div className="request-detail-container">
                        {renderKeyLabels(titles?.request_date)}
                        {renderKeyValues(convertInLocalTimeZone(item?.date_requested))}
                    </div>
                    <div className="request-detail-container">
                        {renderKeyLabels(titles?.service_end_data)}
                        {renderKeyValues(formatDate(item?.scheduled_cancel_date))}
                    </div>
                </div>

                <div className="button-container">
                    {(item?.status === "pending_cancel" ||
                        item?.status === "draft" ||
                        item?.status === "waiting_for_document_approval") && (

                            <CustomButton
                                width={"100%"}
                                className={"undo-button undo-button-title"}
                                text={titles?.undo_my_cancel}
                                onClick={() => onUndoRequest(item)}
                            />
                        )}

                    {(item?.status === "draft" ||
                        item?.status === "waiting_for_document_approval") && (

                            <CustomButton
                                width={"100%"}
                                className={"undo-button finalise-button fialise-button-title"}
                                text={titles?.finalise_cancelation}
                                onClick={() => onFinilizeRequest(item)}
                            />
                        )}

                    <CustomButton
                        width={"100%"}
                        className={"undo-button view-button view-text"}
                        text={titles?.view_request}
                        onClick={() => onPressCard(item)}
                    />
                </div>
            </div>
        )
    }

    return (
        <MainLayout
            text={titles?.serviceRequestList}
            isBackHide={false}
            isSemiHeader={true}
            isNavbar={true}
            white={true}
            snackBarMessage={snackBarMessage}>


            <div className={`request_list_container ${cancelSubscriptionList?.data?.length > 0 ? "with_button" : "without_button"} mb22`}>

                {cancelSubscriptionList?.data?.map((item) => renderSubscriptionItem(item))}
            </div>
            <ConfirmationModal
                show={showUndoRequestPopup}
                title={" "}
                description={
                    isUndoRequest
                        ? titles?.undo_my_cancel_message
                        : titles?.finalise_cancel_message
                }
                btnText={titles?.yes}
                onClose={onClose}
                onClick={() => handleOnConfirmYes()}
            />
            <CustomButton
                width={"100%"}
                height={"50px"}
                className={"sub_submit_btn"}
                text={titles?.create_new_request}
                onClick={() => {
                    history?.push(ROUTES_CONSTANTS.cancelServices, {
                        medicalUserData: medicalUserData,
                    })
                }}
            />
        </MainLayout >
    )
}

export default SubscriptionList